export const environment = {
    production: false,    
    beaconUrl: `https://beaconpprd.biworldwide.com`,
    domain: `https://pprd.outlook.recognitionnow.com`
};
